import HistorySection2Image1 from '../../assets/history_section2_image1.png';
import HistorySection2Image2 from '../../assets/history_section2_image2.png';
import HistorySection2Image3 from '../../assets/history_section2_image3.png';
import HistorySection2Image4 from '../../assets/history_section2_image4.png';

const rawHistoryJson = `[
  {
    "year": "2025 ~ 2022",
    "lines": [
      {
        "index": "2025. 6",
        "description": "기업부설연구소 항남공장 이전 – 연구분야 : 자동화설계"
      },
      {
        "index": "2025. 5",
        "description": "포스코퓨처엠 협력사 등록"
      },
      {
        "index": "2025. 1",
        "description": "비비테크 발달장애인 사내카페 오픈"
      },
      {
        "index": "2024. 11",
        "description": "중소벤처기업부장관상 표창"
      },
      {
        "index": "2024. 11",
        "description": "TV 조선 특집다큐 방영 – '세대를 이어가는 기업가 정신'"
      },
      {
        "index": "2024. 6",
        "description": "비비테크 항남공장 증설 – 반도체 Utility 제작 자동화 공장"
      },
      {
        "index": "2024. 4",
        "description": "독일 Kohlbecker Gesamtplan GmbH와 MOU – 유럽 배터리공장 드라이룸 훅업 설계, 시공"
      },
      {
        "index": "2024. 3",
        "description": "비비테크 장애인 실업 탁구팀 창단 – 전국장애인 체육대회 금∙은∙동메달 모두 획득"
      },
      {
        "index": "2023. 9",
        "description": "ISO 45001 안전보건경영시스템 인증"
      },
      {
        "index": "2022. 12",
        "description": "미국법인 설립 (BBTECH America INC) – 삼성전자 Taylor FAB 협력업체 선정"
      },
      {
        "index": "2022. 1",
        "description": "BBTECH 2.0 선포 – 성진규 대표이사 취임"
      }
    ]
  },
  {
    "year": "2021 ~ 2016",
    "imagePosition": "right",
    "lines": [
      {
        "index": "2021. 12",
        "description": "비비테크 양감공장 증설 (반도체 Utility 제작 Cleanroom)"
      },
      {
        "index": "2021. 1",
        "description": "LG E/V Battery 공장 설비 제작 참여 (美 OHIO州)"
      },
      {
        "index": "2020. 8",
        "description": "비비테크 화성공장 준공 (불소수지코팅 전용 공장)"
      },
      {
        "index": "2020. 1",
        "description": "LG전자 협력사 등록"
      },
      {
        "index": "2019. 8",
        "description": "B社 반도체공장 건설 프로젝트 참여 (中國 濟南)"
      },
      {
        "index": "2017. 1",
        "description": "KBS 「사장님이 美쳤어요」 촬영 및 방영"
      },
      {
        "index": "2016. 12",
        "description": "중소기업청 미래를 이끌 존경받는기업인 선정"
      },
      {
        "index": "2016. 09",
        "description": "ISO14001 환경경영시스템 인증"
      }
    ]
  },
  {
    "year": "2015 ~ 2009",
    "lines": [
      {
        "index": "2015. 7",
        "description": "불소수지코팅제품 \\\"BBFLONDUCT\\\" – 美 FM APPROVALS 인증"
      },
      {
        "index": "2014. 10",
        "description": "성열학 대표이사 대통령상 국민훈장 목련장 수상"
      },
      {
        "index": "2013. 09",
        "description": "삼성전자 중국 서안 반도체 공장 프로젝트 참여"
      },
      {
        "index": "2012. 6",
        "description": "중국법인 설립 (必碧淨化科技(上海)有限公司)"
      },
      {
        "index": "2011. 9",
        "description": "KOSHA18001 안전보건경영시스템 인증"
      },
      {
        "index": "2010. 10",
        "description": "비비테크 오산공장 증설 – 반도체 Utility 제작 Cleanroom"
      },
      {
        "index": "2009. 4",
        "description": "수원본사 신축"
      }
    ]
  },
  {
    "year": "2008 ~ 2004",
    "imagePosition": "right",
    "lines": [
      {
        "index": "2008. 8",
        "description": "기업부설연구소 설립 인증 – 연구분야 : 기계 기구 설계"
      },
      {
        "index": "2007. 12",
        "description": "대한민국 기술대상 우수상 – 벨로우즈 자동용접기 개발"
      },
      {
        "index": "2006. 4",
        "description": "동탄 사옥 신축"
      },
      {
        "index": "2005. 5",
        "description": "ISO9001 품질경영시스템 인증"
      },
      {
        "index": "2004. 10",
        "description": "삼성전자 DS부문 반도체 UTILITY 협력사 등록"
      },
      {
        "index": "2004. 4",
        "description": "㈜비비테크 설립 (경기 화성시 반월동)"
      }
    ]
  }
]`;

const rawHistoryEngJson = `[
  {
    "year": "2025 ~ 2022",
    "lines": [
      {
        "index": "2025. 6",
        "description": "Relocated corporate R&D center to Hangnam Plant (Research: Automation Design)"
      },
      {
        "index": "2025. 5",
        "description": "포스코퓨처엠 협력사 등록"
      },
      {
        "index": "2025. 1",
        "description": "Opened in-house café for people with developmental disabilities"
      },
      {
        "index": "2024. 11",
        "description": "Awarded by the Minister of SMEs and Startups"
      },
      {
        "index": "2024. 11",
        "description": "TV Chosun Special Documentary Aired – 'Entrepreneurial Spirit Across Generations'"
      },
      {
        "index": "2024. 6",
        "description": "Expanded Hangnam Plant (Automated manufacturing plant for semiconductor UTILITY)"
      },
      {
        "index": "2024. 4",
        "description": "Signed MOU with Kohlbecker Gesamtplan GmbH, Germany"
      },
      {
        "index": "2024. 3",
        "description": "Founded BBTECH Disabled Table Tennis Team"
      },
      {
        "index": "2023. 9",
        "description": "Acquired ISO 45001 Occupational Health and Safety Management Certification"
      },
      {
        "index": "2022. 12",
        "description": "Established BBTECH AMERICA INC; Selected as a partner for Samsung Texas FAB"
      },
      {
        "index": "2022. 1",
        "description": "Announced BBTECH 2.0 - CEO Jin-gyu Seong Inaugurated"
      }
    ]
  },
  {
    "year": "2021 ~ 2016",
    "imagePosition": "right",
    "lines": [
      {
        "index": "2021. 12",
        "description": "Expanded Yanggam Plant (Semiconductor UTILITY CLEANROOM)"
      },
      {
        "index": "2021. 1",
        "description": "Participated in LG E/V Battery Plant Equipment Production (OHIO, USA)"
      },
      {
        "index": "2020. 8",
        "description": "Completed Hwaseong Plant (Dedicated Fluoropolymer Coating Facility)"
      },
      {
        "index": "2020. 1",
        "description": "Registered as an LG Electronics Partner"
      },
      {
        "index": "2019. 8",
        "description": "Participated in J Co.'s Semiconductor Plant Project (Jinan, China)"
      },
      {
        "index": "2017. 1",
        "description": "Filmed & Aired KBS Program 'My Boss is Crazy'"
      },
      {
        "index": "2016. 12",
        "description": "Selected as a Respected Entrepreneur Leading the Future by the Small and Medium Business Administration"
      },
      {
        "index": "2016. 09",
        "description": "Acquired ISO14001 Environmental Management Certification"
      }
    ]
  },
  {
    "year": "2015 ~ 2009",
    "lines": [
      {
        "index": "2015. 7",
        "description": "Fluoropolymer Coated Product 'BBFLON DUCT' Received FM APPROVALS Certification (USA)"
      },
      {
        "index": "2014. 10",
        "description": "CEO Yeolhak Seong Awarded Presidential Medal, Order of Civil Merit (Mokryeon Medal)"
      },
      {
        "index": "2013. 09",
        "description": "Participated in S Co.'s Semiconductor Plant Project (Xi'an, China)"
      },
      {
        "index": "2012. 6",
        "description": "Established China Subsidiary (BBTECH PURIFICATION TECH (SHANGHAI) CO., LTD.)"
      },
      {
        "index": "2011. 9",
        "description": "Acquired KOSHA18001 Occupational Health and Safety Management Certification"
      },
      {
        "index": "2010. 10",
        "description": "Expanded Osan Plant (Semiconductor UTILITY CLEANROOM)"
      },
      {
        "index": "2010. 4",
        "description": "Signed 10-Year UTILITY Construction Agreement with 3 Samsung Construction Companies"
      },
      {
        "index": "2009. 4",
        "description": "Constructed Suwon Headquarters"
      }
    ]
  },
  {
    "year": "2008 ~ 2004",
    "imagePosition": "right",
    "lines": [
      {
        "index": "2008. 8",
        "description": "Certified Corporate R&D Center Established (Research: Mechanical Design)"
      },
      {
        "index": "2007. 12",
        "description": "Awarded Korea Technology Grand Prize - Excellence Award (Bellows Automatic Welder Development)"
      },
      {
        "index": "2006. 4",
        "description": "Constructed Dongtan Office Building"
      },
      {
        "index": "2005. 5",
        "description": "Acquired ISO9001 Quality Management Certification"
      },
      {
        "index": "2004. 10",
        "description": "Registered as Semiconductor UTILITY Partner for Samsung DS Division"
      },
      {
        "index": "2004. 4",
        "description": "Founded BBTECH Co., Ltd. (Banwoldong, Hwaseong City)"
      }
    ]
  }
]`;

const rawHistoryChanaJson = `[
  {
    "year": "2025 ~ 2022",
    "lines": [
      {
        "index": "2025. 6",
        "description": "Relocated corporate R&D center to Hangnam Plant (Research: Automation Design)"
      },
      {
        "index": "2025. 5",
        "description": "포스코퓨처엠 협력사 등록"
      },
      {
        "index": "2025. 1",
        "description": "Opened in-house café for people with developmental disabilities"
      },
      {
        "index": "2024. 11",
        "description": "Awarded by the Minister of SMEs and Startups"
      },
      {
        "index": "2024. 11",
        "description": "TV Chosun Special Documentary Aired – 'Entrepreneurial Spirit Across Generations'"
      },
      {
        "index": "2024. 6",
        "description": "Expanded Hangnam Plant (Automated manufacturing plant for semiconductor UTILITY)"
      },
      {
        "index": "2024. 4",
        "description": "Signed MOU with Kohlbecker Gesamtplan GmbH, Germany"
      },
      {
        "index": "2024. 3",
        "description": "Founded BBTECH Disabled Table Tennis Team"
      },
      {
        "index": "2023. 9",
        "description": "Acquired ISO 45001 Occupational Health and Safety Management Certification"
      },
      {
        "index": "2022. 12",
        "description": "Established BBTECH AMERICA INC; Selected as a partner for Samsung Texas FAB"
      },
      {
        "index": "2022. 1",
        "description": "Announced BBTECH 2.0 - CEO Jin-gyu Seong Inaugurated"
      }
    ]
  },
  {
    "year": "2021 ~ 2016",
    "imagePosition": "right",
    "lines": [
      {
        "index": "2021. 12",
        "description": "Expanded Yanggam Plant (Semiconductor UTILITY CLEANROOM)"
      },
      {
        "index": "2021. 1",
        "description": "Participated in LG E/V Battery Plant Equipment Production (OHIO, USA)"
      },
      {
        "index": "2020. 8",
        "description": "Completed Hwaseong Plant (Dedicated Fluoropolymer Coating Facility)"
      },
      {
        "index": "2020. 1",
        "description": "Registered as an LG Electronics Partner"
      },
      {
        "index": "2019. 8",
        "description": "Participated in J Co.'s Semiconductor Plant Project (Jinan, China)"
      },
      {
        "index": "2017. 1",
        "description": "Filmed & Aired KBS Program 'My Boss is Crazy'"
      },
      {
        "index": "2016. 12",
        "description": "Selected as a Respected Entrepreneur Leading the Future by the Small and Medium Business Administration"
      },
      {
        "index": "2016. 09",
        "description": "Acquired ISO14001 Environmental Management Certification"
      }
    ]
  },
  {
    "year": "2015 ~ 2009",
    "lines": [
      {
        "index": "2015. 7",
        "description": "Fluoropolymer Coated Product 'BBFLON DUCT' Received FM APPROVALS Certification (USA)"
      },
      {
        "index": "2014. 10",
        "description": "CEO Yeolhak Seong Awarded Presidential Medal, Order of Civil Merit (Mokryeon Medal)"
      },
      {
        "index": "2013. 09",
        "description": "Participated in S Co.'s Semiconductor Plant Project (Xi'an, China)"
      },
      {
        "index": "2012. 6",
        "description": "Established China Subsidiary (BBTECH PURIFICATION TECH (SHANGHAI) CO., LTD.)"
      },
      {
        "index": "2011. 9",
        "description": "Acquired KOSHA18001 Occupational Health and Safety Management Certification"
      },
      {
        "index": "2010. 10",
        "description": "Expanded Osan Plant (Semiconductor UTILITY CLEANROOM)"
      },
      {
        "index": "2010. 4",
        "description": "Signed 10-Year UTILITY Construction Agreement with 3 Samsung Construction Companies"
      },
      {
        "index": "2009. 4",
        "description": "Constructed Suwon Headquarters"
      }
    ]
  },
  {
    "year": "2008 ~ 2004",
    "imagePosition": "right",
    "lines": [
      {
        "index": "2008. 8",
        "description": "Certified Corporate R&D Center Established (Research: Mechanical Design)"
      },
      {
        "index": "2007. 12",
        "description": "Awarded Korea Technology Grand Prize - Excellence Award (Bellows Automatic Welder Development)"
      },
      {
        "index": "2006. 4",
        "description": "Constructed Dongtan Office Building"
      },
      {
        "index": "2005. 5",
        "description": "Acquired ISO9001 Quality Management Certification"
      },
      {
        "index": "2004. 10",
        "description": "Registered as Semiconductor UTILITY Partner for Samsung DS Division"
      },
      {
        "index": "2004. 4",
        "description": "Founded BBTECH Co., Ltd. (Banwoldong, Hwaseong City)"
      }
    ]
  }
]`;

const yearMessages = [
  '현재',
  '확장기',
  '도약기',
  '창업기'
]

const yearEngMessages = [
  '현재',
  '확장기',
  '도약기',
  '창업기'
]

const yearChaMessages = [
  '현재',
  '확장기',
  '도약기',
  '창업기'
]

const historyImages = [
  HistorySection2Image1,
  HistorySection2Image2,
  HistorySection2Image3,
  HistorySection2Image4
]

// ✅ JSON.parse + imageSrc 추가
export const historyData = JSON.parse(rawHistoryJson).map((item: any, index: number) => ({
  ...item,
  imageSrc: historyImages[index],
  yearMessage: yearMessages[index] ?? '', 
}));

export const historyEngData = JSON.parse(rawHistoryEngJson).map((item: any, index: number) => ({
  ...item,
  imageSrc: historyImages[index],
  yearMessage: yearEngMessages[index] ?? '', 
}));

export const historyChaData = JSON.parse(rawHistoryChanaJson).map((item: any, index: number) => ({
  ...item,
  imageSrc: historyImages[index],
  yearMessage: yearChaMessages[index] ?? '', 
}));
